// Setup the configuration for the merchant
const oysterConfig = {
  cartDrawerElement: document.getElementById('CartDrawer'),
  invertBadgeColor: true,
  apiKey: "api_56imMFi1guGmicxZt",
  integrationID: "integration_2nHpAA4jp6tHrLbbx"
};

// The code below shouldn't need to be touched
window.addEventListener("load", function() {
  window.oyster.init({
    apiKey: oysterConfig.apiKey,
    integrationID: oysterConfig.integrationID,
    platform: "shopify"
  });

  window.oyster.shopify.cart(undefined, { 
    products: [], 
    addBadgeToItems: true, 
    invertBadgeColor: oysterConfig.invertBadgeColor
  });
});